import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { getComponentUiText } from "@/utils/utilities";
import {
  CustomExceptionsUIText,
  GenericExceptionsUIText,
} from "./customExceptions";
import { get } from "lodash";
import { ExceptionTypes } from "@/utils/constants";
import store from "@/store";

export const showError = (
  uiText: string,
  uniqueId = "",
  params?,
  extendText?: string,
) => {
  const message = ` ${extendText ? extendText : ""} ${getComponentUiText(
    uiText,
    false,
    params,
  )}`;
  const activeCallApi = store.state.User.activeCallApi;
  if (!activeCallApi || !message) {
    return;
  }
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message,
    uniqueId,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

export const showErrorAPI = (
  error: any,
  router: string,
  status = 502,
  extendText?: string,
) => {
  const type: string = get(error, "data.error.type", "");
  if (!type) return;
  if (type === ExceptionTypes.OrgPlanNotEntitled) return;
  const uniqueId: string = get(error, "data.error.uniqueId", "");
  if (CustomExceptionsUIText[type])
    if (type === "exc_invalid_email") {
      const email = get(error, "data.error.furtherDetails.recipientEmail", "");
      showError(CustomExceptionsUIText[type], status === 500 ? uniqueId : "", {
        emailAddressProvided: email,
      });
    } else {
      showError(
        CustomExceptionsUIText[type],
        status === 500 ? uniqueId : "",
        {},
        extendText,
      );
    }
  else if (GenericExceptionsUIText[router])
    showError(GenericExceptionsUIText[router], uniqueId);
};

export const showToastMessage = (message: string, type: string) => {
  const emitData: IToastMessage = {
    variant: type,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

export const showSuccessToast = (
  message: string,
  linkText?: string,
  redirectLink?: string,
  delay?: number,
) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.SUCCESS,
    message: message,
    linkText: linkText,
    redirectLink: redirectLink,
    delay: delay,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};
